module.exports = __webpack_public_path__ + "static/media/king-moffatt-building-services.1276c130.png";